<template>
	<div>
		<h4 class="section-title">Edit SME</h4>
		<form @submit.prevent="onSubmit">
			<div class="form-group input-content">
				<label>Email</label>
				<input type="text" v-model="sme_data.email" class="form-control" v-validate="'required'" name="email">
				<span class="input-error-msg">{{ errors.first('email') }}</span>
			</div>
			<div class="form-group input-content">
				<label>First name</label>
				<input type="text" v-model="sme_data.first_name" class="form-control" v-validate="'required'" name="first_name">
				<span class="input-error-msg">{{ errors.first('first_name') }}</span>
			</div>
			<div class="form-group input-content">
				<label>Last name</label>
				<input type="text" v-model="sme_data.last_name" class="form-control" v-validate="'required'" name="last_name">
				<span class="input-error-msg">{{ errors.first('last_name') }}</span>
			</div>
			<button type="submit" class="button">Submit</button>
			<router-link :to="{ name : 'admin.smes.index' }" tag="button" class="button dark-button">Back</router-link>
		</form>
	</div>
</template>

<script>
export default {
	data : function(){
		return {
			id : this.$route.params.id,
			sme_data : {
				email : '',
				first_name : '',
				last_name : ''
			}
		}
	},

	created : function(){
		this.getSME();
	}, 

	methods : {
		getSME : function(){

			var params = {
				id : this.id
			}

			this.$store.dispatch('getSME', params).then((res) => {
				this.sme_data = res.data.data;
			}).catch((error) => {	
				console.log(error);
			})
		},
		onSubmit : function(){

			this.$validator.validateAll().then((result) => {
				if(result){
					this.$store.dispatch('editSME', this.sme_data).then((res) => {
						console.log("OK", res);
						this.$router.push({ name : 'admin.smes.index' });
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/smes/AdminSMEEditComponent.vue